import { Request } from '../../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../../httpClient/serverApi/types/IResponse';

export interface IDeleteAllVersionContentOnSiteParams {}

export interface IDeleteAllVersionContentOnSiteResult extends IResult {
}

export class DeleteAllVersionContentOnSiteRequest
  extends Request<IDeleteAllVersionContentOnSiteParams, IDeleteAllVersionContentOnSiteResult> {

  constructor(params: IDeleteAllVersionContentOnSiteParams = {}) {
    super('deleteAllVersionContentOnSite', params);
  }
}
